import { object, string } from 'yup'

import { i18nErrorCodes } from '../form-utils'

const { required } = i18nErrorCodes

export default object().shape({
  date: string().required(required),
})

export const emptySchedule = {
  date: '',
}



// WEBPACK FOOTER //
// ./src/components/forms/schemas/schedule.schema.ts